/*
 * view for the quick create example editor
 */

define([
  "marionette",
  "modules/quickCreate/quickExampleModal/template/quickExampleModalTemplate.html",
], function (Marionette, QuickExampleModalTemplate) {
  var QuickExampleModalView = {};

  QuickExampleModalView.quickExampleModalLayout = Marionette.Layout.extend({
    template: QuickExampleModalTemplate,
    disableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", true);
    },
    enableDoneButton: function () {
      this.$el.find("#doneButton").prop("disabled", false);
    },
    getCompleteness: function () {
      return this.$el.find("#completeness").prop("checked");
    },
    regions: {
      list: "#examplesList",
      locale: "#locale",
      editor: "#editor",
      gauge: "#gauge",
      translation: "#translation",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return QuickExampleModalView;
});
